import { apiFetch } from "./client.js";
import type { PublicBotConfig } from "@chatfab/shared";

const WS_URL = import.meta.env.VITE_WS_URL ?? "wss://49pg78ajmj.execute-api.us-east-1.amazonaws.com/prod";

export const chatApi = {
  resolveBot: (slug: string) =>
    apiFetch<PublicBotConfig>(`/api/v1/bots/resolve/${slug}`),

  createSession: (bot_id: string, invite_code?: string) =>
    apiFetch<{ session_id: string }>("/api/v1/chat/session/create", { method: "POST", body: JSON.stringify({ bot_id, invite_code }) }),

  createEmbedSession: (slug: string, referrer_url?: string) =>
    apiFetch<{ session_id: string }>("/api/v1/chat/embed/session/create", { method: "POST", body: JSON.stringify({ slug, referrer_url }) }),
};

export { WS_URL };
